import { v4 as uuidv4 } from "uuid";
import { formData, postData } from "@utils";

function getApiCode() {
  return process.env.VUE_APP_API_CODE || "";
}

function optionalApiCode() {
  return getApiCode();
}

function withOptionalToken(payload = {}) {
  const token = optionalApiCode();
  if (token) return { ...payload, token };
  return payload;
}

export function buildUploadId() {
  return uuidv4();
}

export async function qrBranchList({ signal } = {}) {
  return postData(withOptionalToken({ method: "qrActions", func: "branchList" }), signal);
}

export async function qrUploadMedia({ uploadid, file, signal } = {}) {
  const token = optionalApiCode();

  const fd = new FormData();
  if (token) fd.append("token", token);
  fd.append("method", "qrActions");
  fd.append("func", "addMediaQrComplaint");
  fd.append("uploadid", uploadid || buildUploadId());
  fd.append("media_type", "qr_form");
  fd.append("file", file);

  return formData(fd, signal);
}

export async function qrCategoryListAsJson({ qr_channel, qrChannel, signal } = {}) {
  const payload = withOptionalToken({ method: "qrActions", func: "categoryListAsJson" });
  const channel = qr_channel ?? qrChannel;
  if (channel) payload.qr_channel = channel;

  const res = await postData(payload, signal);

  // Backend bu endpointte bazen direkt array döndürebilir.
  // Bu yüzden "res" hem array hem de { error, detail } gibi obje olabilir.
  return res;
}

export async function qrSubmit({
  qr_channel,
  fullname,
  name_withheld,
  branch_customer,
  branch_withheld,
  category,
  category_id,
  message,
  uploadids,
  phone,
  email,
  no_feedback,
  kvkk1,
  kvkk2,
  signal,
} = {}) {
  const token = optionalApiCode();

  const fd = new FormData();
  if (token) fd.append("token", token);
  fd.append("method", "qrActions");
  fd.append("func", "submit");
  fd.append("qr_channel", qr_channel);
  fd.append("fullname", fullname || "");
  fd.append("name_withheld", String(name_withheld ? 1 : 0));
  fd.append("branch_customer", branch_customer || "");
  fd.append("branch_withheld", String(branch_withheld ? 1 : 0));
  const resolvedCategory = category ?? category_id;
  if (
    resolvedCategory !== undefined &&
    resolvedCategory !== null &&
    resolvedCategory !== ""
  ) {
    fd.append("category", String(resolvedCategory));
  }
  fd.append("message", message || "");

  fd.append("phone", phone || "");
  fd.append("email", email || "");
  fd.append("no_feedback", no_feedback === "1" || no_feedback === 1 || no_feedback === true ? "1" : "0");
  fd.append("kvkk1", kvkk1 === "1" || kvkk1 === 1 || kvkk1 === true ? "1" : "0");
  fd.append("kvkk2", kvkk2 === "1" || kvkk2 === 1 || kvkk2 === true ? "1" : "0");

  (uploadids || []).forEach((id) => {
    if (id) fd.append("uploadid[]", id);
  });

  return formData(fd, signal);
}

export async function qrList({ options, search, signal } = {}) {
  const payload = withOptionalToken({
    method: "qrActions",
    func: "list",
  });
  if (options) payload.options = JSON.stringify(options);
  if (search) payload.search = JSON.stringify(search);
  return postData(payload, signal);
}

